import PropTypes from 'prop-types';

const displayName = 'CardDataTable';
const propTypes = {
  title: PropTypes.string,
};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
